import React from "react";
import DocumentListItem from "./DocumentListItem";
import FolderList from "../../../components/Common/FolderList";

/**
 * Component for rendering a list of document folders
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of document data to render
 * @param {React.Component} props.component - Component to use for rendering (defaults to PanelComponent)
 */
const DocumentFolderList = ({ data }) => {
  if (!data || !Array.isArray(data)) {
    return null;
  }

  return (
    <FolderList data={data}>
      {(document, index) => (
        <DocumentListItem key={index} document={document} />
      )}
    </FolderList>
  );
};

export default DocumentFolderList;
